import {withRouter} from 'react-router-dom';

const Splash = () => {
    return (
        <div className={"splash"}>
            <div className="container h-100">
                <div className={"row h-100"}>
                    <div className={"col-12 col-md-7 mx-auto  my-auto  "}>
                        <div className={"row"}>
                            <div className={"col-12 text-center mb-4"}>
                                <p className={"text-black mt-3"}>
                                    Orzax Club'ın ayrıcalıklı dünyasına <b>hoş geldiniz!</b>
                                </p>
                            </div>

                            <div className={"col-12 mt-3"} style={{display: 'flex', justifyContent: 'center'}}>
                                <div className={"col-12 col-md-6"}>
                                    <a href={'/giris-yap'} className="button button-2">
                                        Giriş Yap
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(Splash);
